/**
 * @generated SignedSource<<55fd1e153eeb2c560e0eea23b71954ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectPriorityDropdown_project$data = {
  readonly id: string;
  readonly priorityLevel: {
    readonly id: string;
    readonly name: string | null;
  } | null;
  readonly " $fragmentType": "ProjectPriorityDropdown_project";
};
export type ProjectPriorityDropdown_project$key = {
  readonly " $data"?: ProjectPriorityDropdown_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectPriorityDropdown_project">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectPriorityDropdown_project",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "PriorityLevel",
      "kind": "LinkedField",
      "name": "priorityLevel",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectType",
  "abstractKey": null
};
})();

(node as any).hash = "7317d103179cd9270c54e6ecc395151d";

export default node;
